import type { NextPage } from 'next'
import { GetStaticProps, GetStaticPaths } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { isEmpty } from 'lodash-es'

// Libs

// Components
import LandingPageComponent from '@/components/pages/LandingPage/invitation'

// Constants
import { envConfigs } from '@/constants/config'
import { DEFAULT_LOCALE } from '@/constants/defaultLocale'

// Styles

// Variables

const EventName: NextPage = () => {
  const router = useRouter()
  const { query } = router
  const eventName = query?.eventName

  const currentLocale = router.locale === 'default' ? DEFAULT_LOCALE : router.locale

  const LANDING_PAGE_CONFIG: any = {
    invitation: {
      eventName: 'invitation',
      title: 'Live Mall Club',
      description: 'Live Mall Club',
      imageUrl: '',
      ogUrl: '',
    },
  }

  const isValidEventName = (name: string | string[] | undefined): boolean => {
    if (!name || typeof name !== 'string') return false
    return Object.keys(LANDING_PAGE_CONFIG).includes(name)
  }

  return (
    <>
      {!isEmpty(eventName) && isValidEventName(eventName) && (
        <Head>
          <title>{LANDING_PAGE_CONFIG[`${eventName}`].title}</title>
          <link
            rel='canonical'
            href={`${envConfigs.domainUrl}/${currentLocale}${'/landing-page'}/${LANDING_PAGE_CONFIG[`${eventName}`].eventName}`}
          />
          <meta name='title' key='meta-title' content={LANDING_PAGE_CONFIG[`${eventName}`].title} />
          <meta name='description' key='meta-description' content={LANDING_PAGE_CONFIG[`${eventName}`].description} />
          <meta property='og:title' key='og-title' content={LANDING_PAGE_CONFIG[`${eventName}`].title} />
          <meta property='og:description' key='description' content={LANDING_PAGE_CONFIG[`${eventName}`].description} />
          <meta property='og:url' key='og-url' content={`${envConfigs.domainUrl}/${currentLocale}${router.asPath}`} />
          {!isEmpty(LANDING_PAGE_CONFIG[`${eventName}`].imageUrl) && (
            <meta property='og:image' key='og-image' content={LANDING_PAGE_CONFIG[`${eventName}`].imageUrl} />
          )}
        </Head>
      )}
      <LandingPageComponent />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: { ...(await serverSideTranslations(locale as string, ['common'])) },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}
export default EventName
